/* Imports */
import React from "react"
import { Image } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const ImagePage = () => {
    const items = [
        {
            title: "Auto height",
            content: <Image src="/images/pic-img.jpg" alt="Image" />,
            code: '<Image src="/images/pic-img.jpg" alt="Image" />',
        },
        {
            title: "Fixed height, cover",
            content: (
                <Image
                    src="/images/pic-img.jpg"
                    alt="Image"
                    fit="cover"
                    height={300}
                />
            ),
            code: '<Image src="/images/pic-img.jpg" alt="Image" fit="cover" height={300} />',
        },
        {
            title: "Fixed height, contain",
            content: (
                <Image
                    src="/images/pic-img.jpg"
                    alt="Image"
                    fit="contain"
                    height={300}
                />
            ),
            code: '<Image src="/images/pic-img.jpg" alt="Image" fit="contain" height={300} />',
        },
        {
            title: "With caption",
            content: (
                <Image
                    src="/images/pic-img.jpg"
                    alt="Image"
                    fit="cover"
                    height={300}
                    caption="Caption"
                />
            ),
            code: '<Image src="/images/pic-img.jpg" alt="Image" fit="cover" height={300} caption="Caption" />',
        },
    ]

    const propsItems = [
        {
            name: "src",
            type: "String",
            example: "/images/cover.jpg",
            required: "Yes",
        },
        {
            name: "alt",
            type: "String",
            example: "Cover",
            required: "Yes",
        },
        {
            name: "width",
            type: "Number or String",
            example: "30vw",
            default: "100%",
        },
        {
            name: "height",
            type: "Number or String",
            example: "300",
            default: "auto",
        },
        {
            name: "fit",
            type: "String",
            example: "cover",
            possible: commonProps.objectFit,
        },
        {
            name: "caption",
            type: "String",
            example: "Landscape",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ImagePage
